function requestAPI() {
  return fetch(`${process.env.REACT_APP_BASE_URL}setting-referral`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((res) => res.json())
}

export default function actionSettingReferral() {
  return async (dispatch) => {
    dispatch({
      type: 'GET_SETTING_REFERRAL_BEGIN'
    })

    try {
      const result = await requestAPI()
      if (!result.status) {
        handleErrors(dispatch, result)
        return
      }

      dispatch({
        type: 'GET_SETTING_REFERRAL_SUCCESS',
        payload: result.data
      })
    } catch (err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({
    type: 'GET_SETTING_REFERRAL_FAILURE',
    error: error
  })
}
